import React, { Component } from "react";
import { shopCartItems } from "./services";
import { MdClose } from "react-icons/md";
import ProductCard from "../../../base/features/blocks/ProductCard";
import Spinner from "../../../base/features/micro/Spinner";
import Footer from "../blocks/Footer";
import Empty from "../../../base/features/blocks/Empty";
import WaitToPayCartsBlock from "./WaitToPayCartsBlock";
import DynamicView from "../../dynamicView/DynamicView";
import { getShopUid } from "../../../settings/domainManager";
import { navigate_to_cart_finalize } from "../../../navigator/user/cart";

class ShopCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: null,
      shop_uid: "",
      payable_price: null,
    };
  }

  componentDidMount() {
    this.getCartData();
  }

  get shopId() {
    return getShopUid();
  }

  updateView(data) {
    if (data) {
      this.setState({
        products: data.items,
        waitToPayCarts: data.wait_to_pay_invoices,
        shop_uid: data.shop.uid,
        payable_price: data.payable_price,
        can_continue: data.can_continue,
        messages: data.messages,
        views: data.views,
      });
    }
  }

  getCartData() {
    shopCartItems(this.shopId).then((data) => {
      this.updateView(data);
    });
  }

  render() {
    return (
      <div className="container-fluid px-0" dir="rtl">
        <header
          className="row mx-0 position-fixed px-3 py-2-3 border-bottom bg-white"
          style={{ top: "0", left: "0", right: "0", zIndex: "4" }}
        >
          <div className="col">
            <h1 className="fs-4 fw-bolder mb-0">سبد خرید</h1>
          </div>
          <div className="col-auto align-self-center">
            <MdClose
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
        </header>
        <body
          className="row mx-0 px-0"
          style={{ marginTop: "60px", marginBottom: "80px" }}
        >
          {this.state.waitToPayCarts &&
            this.state.waitToPayCarts.map((cart, c) => (
              <div key={c} className="col-12 px-4 py-3 border-bottom">
                <WaitToPayCartsBlock cart={cart} />
              </div>
            ))}
          {this.state.messages &&
            this.state.messages.length > 0 &&
            this.state.messages.map((item) => (
              <div className="alert alert-danger"> {item.msg} </div>
            ))}
          {this.state.products ? (
            this.state.products.length > 0 ? (
              this.state.products.map((product, p) => (
                <div key={p} className="col-12 px-0 border-bottom">
                  <ProductCard
                    product={product.product}
                    shopUid={this.state.shop_uid}
                    payable_price={product.payable_price}
                    quantity={product.quantity}
                    cartMode={true}
                    quantityChanged={(data) => this.updateView(data)}
                  />
                </div>
              ))
            ) : (
              this.state.products.length === 0 && (
                <Empty text={"سبد خرید شما خالی است."} />
              )
            )
          ) : (
            <Spinner />
          )}
        </body>

        {this.state.views && this.state.views.footer && (
          <footer
            className="row py-2-3 px-3 mx-0 position-fixed bg-white shadow-sm"
            style={{ bottom: "0", left: "0", right: "0", zIndex: "4" }}
          >
            <DynamicView viewPage="shopHome" view={this.state.views.footer} />
          </footer>
        )}
        {this.state.products &&
          this.state.payable_price &&
          this.state.products.length > 0 && (
            <Footer
              payable_price={this.state.payable_price}
              btnText={"ادامه فرایند خرید"}
              path={navigate_to_cart_finalize()}
              isDisabled={!this.state.can_continue}
            />
          )}
      </div>
    );
  }
}

export default ShopCart;
